import { List, Pagination, Typography } from "antd";
import "./supervision-projects-page.scss";
import { SupervisionProjectCard } from "../supervision-poject-card";
import { SupervisionProjectsFilters } from "../supervision-projects-filters";

type RightBlockCounters = {
  type: "counters";
  incoming: number;
  outgoing: number;
  processing: number;
};

type RightBlockAction = {
  type: "action";
  message: string;
  actionText: string;
};

type RightBlock = RightBlockCounters | RightBlockAction;

export interface SupervisionProject {
  supervisionId: string;
  title: string;
  address: string;
  authority: string;
  right: RightBlock;
}

const MOCK_PROJECTS: SupervisionProject[] = [
  {
    supervisionId: "8cf4c8ac-0a57-4d27-ad06-f8b4fa06ffb6",
    title: "Бизнес-центр «Невский»",
    address: "г. Санкт-Петербург, Соколиная гора, ул. Мироновская, возле д. 46",
    authority:
      "Служба государственного строительного надзора и экспертизы Санкт-Петербурга",
    right: { type: "counters", incoming: 9, outgoing: 9, processing: 9 },
  },
  {
    supervisionId: "e2c761a3-f5a4-4244-b15a-50054aba5df5",
    title: "Жилой дом с инженерными сетями и благоустройством территории",
    address:
      "г. Москва, район Дмитровский, Дмитровское ш., влд.127 (Северный административный)",
    authority:
      "Служба государственного строительного надзора и экспертизы Санкт-Петербурга",
    right: { type: "counters", incoming: 9, outgoing: 9, processing: 9 },
  },
  {
    supervisionId: "797b72d8-05cd-4a69-9e00-43d3357c8124",
    title: "ЖК «Капитал»",
    address: "г. Москва, Воробьёвы горы, ул. Воробьёв,4",
    authority: "Московский государственный строительный надзор",
    right: { type: "counters", incoming: 9, outgoing: 9, processing: 9 },
  },
  {
    supervisionId: "f37d2a74-f9df-40cb-a52a-d2867b3c4b7f",
      title: "ЖК «Авангард»",
    address: "г. Москва, ул, Затейливая, 126 А",
    authority: "",
    right: {
      type: "action",
      message:
        "Объект не подключен к интеграционному каналу и не получает сообщений",
      actionText: "Подключить",
    },
  },
  {
      title: "ЖК «Авангард»",
    address: "г. Москва, ул, Затейливая, 126 А",
    supervisionId: "3204d10f-1606-4651-9c91-c231ba458765",
    authority: "",
    right: {
      type: "action",
      message:
        "У объекта нет действующего администратора, назначьте для управления этим объектом",
      actionText: "Назначить администратора",
    },
  },
];

const { Title } = Typography;

export const SupervisionProjectsPage = () => {
  const data = MOCK_PROJECTS;

  return (
    <div className="supervision-page">
      <Title level={3} style={{ lineHeight: "32px" }}>
        Надзорное дело
      </Title>

      <SupervisionProjectsFilters />

      <List
        dataSource={data}
        split={false}
        style={{ marginTop: "12px" }}
        renderItem={(item) => (
          <List.Item style={{ padding: 0, marginBottom: "8px" }}>
            <SupervisionProjectCard project={item} />
          </List.Item>
        )}
      />

      <Pagination
        current={1}
        total={100}
        pageSize={10}
        showSizeChanger
        showTotal={(_total, range) => `${range[0]}-${range[1]}`}
        pageSizeOptions={["10", "20", "50", "100"]}
        style={{ marginTop: "16px" }}
        simple
      />
    </div>
  );
};

